<template>
<div>

    <div class="contactUsCont" v-if="contactStyle1">
        <div class="contactStyleBox">
            <p class="contactCommonTitle contactUsIcon">联系我们</p>
            <div class="contactDetailInfor">
                <p>地址：{{site.site_address}}</p>
                <p>邮编：{{site.site_code}}</p>
            </div>
        </div>

        <div class="contactStyleBox">
            <p class="contactCommonTitle weinxinContactIcon">微信客服</p>
            <div class="contactDetailInfor weixinContactDetailInfor">
                <img class="weixinCode" :src="site.site_staff_qrcode"/>
                <p>微信客服二维码</p>
            </div>
        </div>
    </div>


    <div class="contactUsCont" v-if="contactStyle2">
        <div class="contactStyleBox">
            <p class="contactCommonTitle contactUsIcon">联系我们</p>
            <div class="contactDetailInfor">
                <p>地址：{{site.site_address}}</p>
                <p>邮编：{{site.site_code}}</p>
            </div>
        </div>

        <div class="contactStyleBox">
            <p class="contactCommonTitle weinxinContactIcon">微信客服</p>
            <div class="contactDetailInfor weixinContactDetailInfor">
                <img class="weixinCode" :src="site.site_staff_qrcode" />
                <p>微信客服二维码</p>
            </div>
        </div>

        <div class="contactStyleBox">
            <p class="contactCommonTitle weinxinContactIcon">工作时间</p>
            <div class="contactDetailInfor jobTimeDetailInfor">              
                <p>周一至周五（法定节假日休息）</p>
                <p>上午：{{site.site_work_time_am}} </p>
                <p>下午：{{site.site_work_time_pm}} </p>
                <p>周五内部学习</p>
          
            </div>
        </div>

    </div>
</div>

</template>

<script>
import { mapState } from "vuex";
export default {
    name:'',
    components: {

    },

    computed: {
        ...mapState({
            site: state => state.user.site
        }),
    },
    props: {
        contactStyle1: {
            type:Boolean,
            default:false
        },
        contactStyle2: {
            type:Boolean,
            default:false            
        },
       
    },
   
    data(){
        return {

        }
    },
    created() {

    },

    mounted() {
     
    }
    ,
    methods:{



    }
}
</script>

<style scoped>
    .contactUsCont {
        border-radius:4px;
        border:2px solid rgba(252,248,241,1);
    }
    .contactStyleBox {

    }

    .contactCommonTitle {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
        color:#0173FF;
        background:#fcf8f1;
        border-radius:4px 4px 0px 0px;
       
        padding-left:45px;
    }

    .contactUsIcon {
        background:url('../../assets/images/contact_icon.png') no-repeat 10px center #fcf8f1;
        background-size:22px auto;
    }
    .weinxinContactIcon{
        background:url('../../assets/images/weixin_icon.png') no-repeat 10px center #fcf8f1;
        background-size:22px auto;     
    }

    .contactDetailInfor {
        padding:25px 20px;
        color:#666;
        font-size:14px;
    }
    .contactDetailInfor>p{
        margin-bottom:10px;

    }

    .weixinContactDetailInfor {
        text-align: center;
    }
    .weixinCode{
        display:block;
        width:124px;
        margin: 0 auto;
    }

    .jobTimeDetailInfor > p {
        margin-bottom:5px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/common/contactUs.vue